module.exports = __webpack_public_path__ + "media/images/flags/LB-60426538826d447b6ebac463d0a7222f.svg";